export const DEFAULT_SKILL_NAME = 'Otros';

export const DEFAULT_SKIP_ONBOARDING_DATA = {
  accountType: 'PERSON',
  personaForm: {
    name: 'Usuario',
    lastName: 'Edify',
    tel: '',
    webSite: '',
    bio: '',
  },
  empresaForm: {
    companyName: 'Empresa Edify',
    tel: '',
    webSite: '',
    bio: '',
  },
  userSkills: [],
  workZones: [],
  allCountry: true,
  userImage: null,
  isFromSkipOnboarding: true,
};

export const FORM_VALIDATION = {
  PERSONA: {
    NAME_MIN_LENGTH: 2,
    NAME_MAX_LENGTH: 50,
    LASTNAME_MIN_LENGTH: 2,
    LASTNAME_MAX_LENGTH: 50,
  },
  EMPRESA: {
    COMPANY_NAME_MIN_LENGTH: 2,
    COMPANY_NAME_MAX_LENGTH: 100,
  },
  PHONE_PATTERN: /^[0-9+\-\s()]*$/,
  URL_PATTERN: /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/,
} as const;

export const ONBOARDING_STEPS = {
  SELECT_TYPE: 1,
  ACCOUNT_DATA: 2,
  WORK_ZONES: 3,
  SUMMARY: 4,
} as const;

export const IMAGE_VALIDATION = {
  MAX_SIZE: 5 * 1024 * 1024,
  ACCEPTED_FORMATS: ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'],
  COMPRESSED_MAX_WIDTH: 800,
  COMPRESSED_MAX_HEIGHT: 800,
  COMPRESSION_QUALITY: 0.8,
} as const;
